import { useMutation } from "@apollo/client";
import { GridRowId } from "@mui/x-data-grid";
import { GET_PEOPLE_WITH_SESSION_COUNT } from "../../../../features/graphql/query";
import { ASSIGN_LOCATION_PERSON_MUTATION, UNASSIGN_LOCATION_PERSON_MUTATION } from "../../../../features/graphql/mutation";
const DEFAULT_PAGE_SIZE = 10;
const useLocationAssignment = (locationId: string) => {
    const [assignPersons] = useMutation(ASSIGN_LOCATION_PERSON_MUTATION, {
        refetchQueries: [{
            query: GET_PEOPLE_WITH_SESSION_COUNT,
            variables: {
                query: "",
                first: DEFAULT_PAGE_SIZE
            }
            //TODO: PROBABLY A QUERY PERSON AS WELL
        }]
    })
    const [unassignPersons] = useMutation(UNASSIGN_LOCATION_PERSON_MUTATION, {
        refetchQueries: [{
            query: GET_PEOPLE_WITH_SESSION_COUNT,
            variables: {
                query: "",
                first: DEFAULT_PAGE_SIZE
            }
            //TODO: PROBABLY A QUERY PERSON AS WELL

        }]
    })
    const savePersons = async (assignments: GridRowId[], unassignments: GridRowId[]): Promise<number> => {

        let references = 0;
        // Exit early if there are no changes to be made
        if (assignments.length === 0 && unassignments.length === 0) {
            console.trace("Attempting to save changes but no assigment or unassigment IDs are provided");
            return 0;
        }

        if (assignments.length > 0) {
            if (process.env.NODE_ENV === "development")
                console.trace(`Attempting assigning persons to student ${locationId}`, assignments);
            const response = await assignPersons({
                variables: {
                    locationId,
                    personIds: assignments
                }
            });

            references = response.data?.assignLocationPersons?.totalStaff ?? 0;

            if (process.env.NODE_ENV === "development")
                console.trace(`Successfully assigned persons to student ${locationId}`);

            if (response.errors?.length ?? 0 > 0)
                console.error("Student Assignment Failure", response.errors);
        }

        if (unassignments.length > 0) {
            if (process.env.NODE_ENV === "development")
                console.trace(`Attempting unassigning persons for student ${locationId}`, assignments);
            const response = await unassignPersons({
                variables: {
                    locationId,
                    personIds: unassignments
                }
            });

            references = response.data?.unassignLocationPersons.totalStaff ?? 0;

            if (process.env.NODE_ENV === "development")
                console.trace(`Successfully unassigned persons to student ${locationId}`);

            if (response.errors?.length ?? 0 > 0)
                console.error("Student Unassignment Failure", response.errors);
        }

        return references;
    }
    return { savePersons };
}

export default useLocationAssignment